/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const AutomaticLtiRoleEnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('AUTOMATIC_LTI_ROLE_ENABLED')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class AutomaticLtiRoleEnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AutomaticLtiRoleEnabledSettingParser.decode(input).map(res => new AutomaticLtiRoleEnabledSetting(res));
    }
    static unsafeDecode(input) {
        return AutomaticLtiRoleEnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AutomaticLtiRoleEnabledSettingParser.encode(data);
    }
    static schema() {
        return AutomaticLtiRoleEnabledSettingParser.schema();
    }
}
